/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-08-16 14:11:09
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-09 11:33:55
 */
import { Button, TableColumnType } from 'antd'
import { getRiskName } from '../../models/rule'

export const ExceptionMessageColumn = (
  onclick: (t: 'look', id: number) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      width: '4rem',
      align: 'center',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    // {
    //   title: "执法ID",
    //   dataIndex: "dataCode",
    //   align: "center",
    //   render: (_, r) => <span onClick={copy}>{r.dataCode}</span>,
    // },
    {
      title: '预警规则',
      dataIndex: 'ruleName',
      align: 'left',
    },
    // {
    //   title: '上报卫健委(局)',
    //   dataIndex: 'osName',
    //   align: 'center',
    // },
    {
      title: '预警机构',
      dataIndex: 'orgName',
      align: 'left',
    },
    {
      title: '预警时间',
      dataIndex: 'cautionTime',
      align: 'center',
    },
    {
      title: '上传时间',
      dataIndex: 'uploadTime',
      align: 'center',
    },
    {
      title: '风险等级',
      dataIndex: 'ruleName',
      align: 'center',
      render: (_, r) => {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html: r?.cautionLevel,
            }}
          ></div>
        )
      },
    },
    // {
    //   title: "处理状态",
    //   width: "5rem",
    //   dataIndex: "disposeStatus",
    //   align: "center",
    //   render: (_, r) =>
    //     r.disposeStatus === 0  ? "未处理" : r.disposeStatus === 1 ? "已处理" :"-",
    // },

    {
      title: '操作',
      align: 'center',
      width: '8rem',
      render: function Element(_, t) {
        return (
          <div>
            <Button
              type='primary'
              ghost
              size='small'
              onClick={() => {
                onclick('look', t.cautionId)
              }}
            >
              查看详情
            </Button>
          </div>
        )
      },
    },
  ]
}
